import {config as numberColumnConfig} from '../../common/NumberColumn';

const prop = 'rNTotal';

export const config = (labels) =>
	numberColumnConfig({
		id: 'totalNotes',
		label: labels.totalNotesLabel,
		prop,
		getNumber: (item) => {
			return (
				(item.rNO || 0) +
				(item.rNCLow || 0) +
				(item.rNCMed || 0) +
				(item.rNCHigh || 0) +
				(item.rNCCrit || 0) +
				(item.rNCloMed || 0) +
				(item.rNCloLow || 0) +
				(item.rNCloCrit || 0) +
				(item.rNCloHigh || 0)
			);
		},
		width: 'minmax(var(--px-150), 1fr)'
	});
